import { ExportButtonDropdown, ExportType, GlobalPeriodSelect } from '@components'

import { Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useDownloadExportFile } from '@features/exports/hooks/useDownloadExportFile'

import { PeriodMode } from '../../../../enums/periodMode'
import { useSegment } from '../../../../hooks'
import { PeriodValue } from '../../../../types/periodValue'
import { useExportsPeriodValue } from '../../hooks/useExportsPeriodValue'
import { ExportsCard } from '../ExportsCard'

const BALANCE_LIST_EXPORT_URL = 'balanceList'

export const BalanceList = () => {
  const { t } = useTranslation()
  const { encodedPeriodValue, period, setPeriod } = useExportsPeriodValue()
  const { downloadExportFile } = useDownloadExportFile()
  const { track } = useSegment()

  const handleSelect = useCallback(
    (_: string, type: ExportType) => {
      downloadExportFile({
        exportUrl: BALANCE_LIST_EXPORT_URL,
        type,
        queryParams: {
          ...(encodedPeriodValue && encodedPeriodValue !== PeriodMode.All ? { period: encodedPeriodValue } : {}),
        },
      })

      track('XXX - Mikkel - Exports', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        export_type: 'Balance list',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        file_format: type,
        period: period.value,
      })
    },
    [downloadExportFile, encodedPeriodValue, period.value, track],
  )
  const handleChangePeriod = useCallback(
    (newPeriod: PeriodValue) => {
      setPeriod(newPeriod)
    },
    [setPeriod],
  )

  return (
    <ExportsCard
      description={t('exports.card.balance_list.description')}
      title={t('exports.card.balance_list.title')}
      actionButton={
        <ExportButtonDropdown
          exportTypesToSkip={[ExportType.RegnskabBasis, ExportType.Html]}
          onSelect={handleSelect}
          variant="outlined"
          fullWidth
        />
      }
    >
      <div>
        <Text colorVariant="label" weight="medium">
          {t('exports.period')}
        </Text>
        <GlobalPeriodSelect encodedPeriod={encodedPeriodValue} onChange={handleChangePeriod} fullWidth />
      </div>
    </ExportsCard>
  )
}
